import { apiService } from './apiService';

export interface IArtist {
  _id: string;
  name: string;
  country: string;
  subtitle: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export const artistApi = {
  // Get all artists
  getArtists: async (): Promise<IArtist[]> => {
    try {
      const response = await apiService.get('/artists');
      return response.data?.artists || [];
    } catch (error: any) {
      console.error('Error fetching artists:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch artists');
    }
  },

  // Get artist by ID
  getArtistById: async (artistId: string): Promise<IArtist> => {
    try {
      const response = await apiService.get(`/artists/${artistId}`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching artist:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch artist');
    }
  }
};
